import { api } from "..";

import { RiskConfig } from "@/types/ApiResponses/Risk";

export const getRiskConfig = async (props: {
  signal?: AbortSignal;
}): Promise<RiskConfig> => {
  const res = await api.client.get("/risk/config", { signal: props.signal });
  return res.data;
};
